import { Injectable } from '@angular/core';
import { TranslateService } from 'ng2-translate/ng2-translate';

declare var $: any;
declare var toastr: any;

@Injectable()
export class DcToaster {
  constructor(public translate: TranslateService) {
  }

  show(message, title, type) {
    toastr.options = {
      closeButton: true,
      debug: false,
      positionClass: 'toast-top-right',
      onclick: null,
      showDuration: 500,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000,
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut'
    };

    toastr[type](this.translate.instant(message), this.translate.instant(title));
  }

  success(message, title = 'toaster.default_success_title') {
    this.show(message, title, 'success');
  }

  info(message, title = 'toaster.default_info_title') {
    this.show(message, title, 'info');
  }

  warning(message, title = 'toaster.default_warning_title') {
    this.show(message, title, 'warning');
  }

  error(message, title = 'toaster.default_error_title') {
    this.show(message, title, 'error');
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/common/services/toaster.service.ts